//* Libraries imports
import { useNavigate, useParams } from 'react-router-dom';

//* Hooks imports
import { useGetProcessById } from '../../../../../hooks/queries/process/use-get-process';
import { useGetResourceQuestionById } from '../../../../../hooks/queries/resource-question/use-get-resource-question';

//* Components imports
import { ViewHeaderProcess } from '../../../../ProcessView/view/_components/view-header-process';
import { ErrorMessages } from '../../../../../component/common/ErrorMessages';
import { ResourceQuestionForm } from "./resource-question-form";
import { ProcessStatus } from '../../../../../component/common/ProcessStatus';
import { ResourceQuestionSkeleton } from '../../../../../skeleton/ResourceQuestionSkeleton/resource-question-skeleton';


export function Content() {   const navigate = useNavigate();
  const { id, questionId } = useParams<{ id: string, questionId?: string }>();
  const processId = id ? parseInt(id) : 0;
  const processQuery = useGetProcessById(processId);
  const resourceQuestionQuery = useGetResourceQuestionById(questionId);
  const { isLoading, isError, data: processResponse } = processQuery;
  
  const { 
    isLoading: isLoadingResourceQuestion, 
    isError: isErrorResourceQuestion, 
    data: resourceQuestionResponse 
  } = resourceQuestionQuery;
  

  if (!processId) {
    navigate(-1);
    return null;
  }


  const handleBack = () => {
    navigate(-1);
  };

  const renderMainContent = () => {
    const process = processResponse!.data!;
    
    // Check if process is finished
    if (!process.isFinished) {
      return (
        <div className="d-flex justify-content-center align-items-center min-vh-100 w-100">

          <ProcessStatus
            type="in-progress"
            title="Processo em Andamento"
            subtitle={process.name}
            message="Este processo seletivo ainda não foi finalizado. O formulário de recursos estará disponível assim que o processo for concluído."
            actionLabel="Voltar ao Processo"
            onAction={handleBack}
          />
        </div>
      );
    }

    return (
      <div className="w-100">
        <ViewHeaderProcess
          processName={process?.name}
          handleBack={handleBack}
          isOnline={process?.online}
          startDate={process?.start?.human?.date}
          endDate={process?.end?.human?.date}
          collegeName={process?.college?.name}
        />          
        <div className="mt-4">
          <ResourceQuestionForm 
            resourceQuestionData={questionId && resourceQuestionResponse?.data ? resourceQuestionResponse.data : undefined}
            isLoadingResourceQuestion={isLoadingResourceQuestion}
            isErrorResourceQuestion={isErrorResourceQuestion}
            isEditMode={!!questionId}
          />
        </div>
      </div>
    );
  };
  return isLoading ? (
    <ResourceQuestionSkeleton />
  ) : isError || !processResponse?.success || !processResponse?.data ? (
    <ErrorMessages
      messages={[
        processResponse?.message ||
          "Não foi possível carregar os detalhes do processo.",
      ]}
      clearErrors={handleBack}
    />
  ) : (
    renderMainContent()
  );
}